import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'
import { toOrdinal, toWords, toWordsOrdinal } from 'number-to-words'
import locales from './locales'

i18n.use(LanguageDetector)
    .use(reactI18nextModule)
    .init({
        fallbackLng: 'en',

        resources: {
            en: {
                translation: locales.en
            }
        },

        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            format: (value, format, lng) => {
                if (format === 'toOrdinal') return toOrdinal(value)
                if (format === 'toWords') return toWords(value)
                if (format === 'toWordsOrdinal') return toWordsOrdinal(value)
                return value
            },
            escapeValue: false // not needed for react!!
        },

        react: {
            wait: true
        }
    })

export default i18n



// WEBPACK FOOTER //
// src/lang/i18n.js